/**
 * Success Modal Component
 */
import React from 'react';

const SuccessModal = ({ visible, onClose }) => {
  if (!visible) return null;

  const handleClose = () => {
    // Close modal and reset the form
    onClose(true); // Pass true to indicate form should be reset
  };

  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        <div className="success-icon">✓</div>
        <h2 className="success-title">Application Submitted!</h2>
        <p className="success-message">
          Thank you for submitting your loan application. Our team will review your information and contact you shortly.
        </p>
        <button className="primary-button" onClick={handleClose}>
          Close
        </button>
        <style jsx>{`
          .success-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
          }
          
          .success-modal {
            background-color: white;
            border-radius: 12px;
            padding: 32px;
            width: 100%;
            max-width: 500px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            text-align: center;
          }
          
          .success-icon {
            background: #78D3CE;
            color: white;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 40px;
            margin: 0 auto 24px;
          }
          
          .success-title {
            font-size: 24px;
            color: #333;
            margin-bottom: 16px;
          }
          
          .success-message {
            color: #666;
            margin-bottom: 24px;
            line-height: 1.6;
          }
          
          .primary-button {
            background: #78D3CE;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
            transition: background 0.3s;
          }
          
          .primary-button:hover {
            background: #66c2bd;
          }
        `}</style>
      </div>
    </div>
  );
};

export default SuccessModal;
